import { render, staticRenderFns } from "./MealGoodsGrid.vue?vue&type=template&id=46cd80f1&scoped=true"
import script from "./MealGoodsGrid.vue?vue&type=script&lang=js"
export * from "./MealGoodsGrid.vue?vue&type=script&lang=js"
import style0 from "./MealGoodsGrid.vue?vue&type=style&index=0&id=46cd80f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46cd80f1",
  null
  
)

export default component.exports